import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  margin-right: calc(50% - 50vw);
  margin-left: calc(50% - 50vw);
  padding: 10vh 0 5vh;
  box-sizing: border-box;
  background-color: ${(props) => props.color};
  @media screen and (max-width: ${(props) => props.width + 1}px) {
    padding: 15% 0 10%;
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: ${(props) => props.width}px;
  margin: auto;
  padding: 0 1.5rem;
  box-sizing: border-box;
  @media screen and (min-width: ${(props) => props.width + 1}px) {
    padding: 0;
  }
`

export const BackgroundColor = ({width, color, children}) => {
  return (
    <Wrapper color={color} width={width}>
      <Content width={width}>
        {children}
      </Content>
    </Wrapper>
  )
}